module.exports = __webpack_public_path__ + "img/ES04.d1a2d80d.svg";